import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Select, message } from 'antd';
import twAreas from '../../../assets/areas/tw-areas.json'
import { addressAdd, addressList, addressUpdate } from "../../../API/address";
import { showLoding } from "../../../utils/tool";
import { useSelector } from "react-redux";
import icon6 from '../../../assets/image/icon6.png'

const ComponentName: React.FC = () => {
  const { t } = useTranslation();
  const [isEdit, setIsEdit] = React.useState(false); 
  const [town, setTown]: any = useState('中正區')
  const handleCountyChange = (value: string) => {
    setCounty(value)
    setTown(undefined) // 切换县市时，重置第二层
  }
  const handleTownChange = (value: string) => {
    setTown(value)
  }
  const [county, setCounty] = useState<string>()
  // 第一层：县 / 市
  const countyOptions = Object.keys(twAreas).map(name => ({
    label: name,
    value: name
  }))
  // 第二层：镇 / 区（依赖第一层）
  const townOptions = useMemo(() => {
    if (!county) return [];
    return (twAreas as any)[county]?.towns.map((name: any) => ({
      label: name,
      value: name
    })) ?? [];
  }, [county]);

  const [lastName, setLastName] = useState<string>('')
  const [firstName, setFirstName] = useState<string>('')
  const [phone, setPhone] = useState<string>('')
  const [companyName, setCompanyName] = useState<string>('')
  const [country, setCountry] = useState<string>('台灣')
  const [postalCode, setPostalCode] = useState<string>('')
  const [streetAddress, setStreetAddress] = useState<string>('')
  const handleAdd = () => {
    if (!lastName || !firstName || !phone || !country || !county || !town || !postalCode || !streetAddress) {
      return message.error('請填寫完整資料')
    }
    showLoding(true)
    addressAdd({
      lastName,
      firstName,
      phone,
      companyName,
      country,
      city: county,
      district: town,
      postalCode,
      streetAddress
    }).then(res => {
      setIsEdit(false)
      message.success('提交成功')
      handleLoadAddress()
    }).catch(err => {
      console.log(err)
    }).finally(() => {
      showLoding(false)
    })
  }
  const handlEdit = () => {
    addressUpdate({
      id: addressLi[0]?.id,
      lastName,
      firstName,
      phone,
      companyName,
      country,
      city: county,
      district: town,
      postalCode,
      streetAddress
    }).then(res => {
      setIsEdit(false)
      message.success('修改成功')
      handleLoadAddress()
    }).catch(err => {
      console.log(err)
    }).finally(() => {
      showLoding(false)
    })
  }

  const [addressLi, setAddressLi]: any = useState([])
  const token = useSelector((state: any) => state?.token)
  const handleLoadAddress = () => {
    addressList().then(res => {
      setAddressLi(res?.data)
      if (res?.data?.length > 0) {
        setLastName(res?.data[0]?.lastName)
        setFirstName(res?.data[0]?.firstName)
        setPhone(res?.data[0]?.phone)
        setCompanyName(res?.data[0]?.companyName)
        setCountry(res?.data[0]?.country)
        setPostalCode(res?.data[0]?.postalCode)
        setStreetAddress(res?.data[0]?.streetAddress)
        setCounty(res?.data[0]?.city)
        setTown(res?.data[0]?.district)
      }
    }).catch(err => {
      console.log(err)
    })
  }
  useEffect(() => {
    if (!token) return
    handleLoadAddress()
  }, [token])

  return (
    <div className="">
      <div className="text-[#595959] text-[16px]">下列的地址將會在您結帳時自動使用，但您還是可以在結帳時修改成其它地址。</div> 
      <div className="">
        <div className="text-[#181512] text-[30px] font-bold my-20 ">
          運送地址
        </div>
        <div className={`${!isEdit ? 'block' : 'hidden'}`}>
          <div className="underline text-[#2d634e] text-[16px] cursor-pointer"
            onClick={() => setIsEdit(true)}
          >編輯地址</div>
          {
            addressLi && addressLi.length > 0 ?
              <div className=" px-[20px] py-[30px] mb-20 rounded-md"
                style={{
                  background: `url(${icon6})`,
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat"
                }}>
                <div className="text-[#595959] text-[16px]">{addressLi[0]?.lastName} {addressLi[0]?.firstName}</div>
                <div className="text-[#595959] text-[16px]">
                  {addressLi[0]?.country}{addressLi[0]?.city}{addressLi[0]?.district},
                  {addressLi[0]?.streetAddress}
                </div>
              </div>
              :
              <div className="text-[#595959] text-[16px] pt-[30px]">您還沒有添加地址</div>
          }
        </div>

        <div className={`${isEdit ? 'block' : 'hidden'}`}>
          <div className="flex h5:block">
            <div className="flex-1">
              <div className="flex items-center mb-[20px] text-[#181512] text-[18px] h5:mb-10">
                姓氏
                <div className="text-[red] text-[18px] ml-10">*</div>
              </div>
              <div className="flex pb-[36px] h5:pb-[16px]">
                <input type="text"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  className="flex-1 px-[15px] py-[10px] rounded-md outline-none text-[#181512] text-[18px]"
                  style={{
                    border: "1px solid #cfc8d8",
                  }} />
              </div>
            </div>
            <div className="w-[8%]"></div>
            <div className="flex-1">
              <div className="flex items-center mb-[20px] text-[#181512] text-[18px] h5:mb-10">
                名字
                <div className="text-[red] text-[18px] ml-10">*</div>
              </div>
              <div className="flex pb-[36px] h5:pb-[16px]">
                <input type="text"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  className="flex-1 px-[15px] py-[10px] rounded-md outline-none text-[#181512] text-[18px]"
                  style={{
                    border: "1px solid #cfc8d8",
                  }} />
              </div>
            </div>
          </div>
          <div className="flex h5:block">
            <div className="flex-1">
              <div className="flex items-center mb-[20px] text-[#181512] text-[18px] h5:mb-10">
                聯絡電話
                <div className="text-[red] text-[18px] ml-10">*</div>
              </div>
              <div className="flex pb-[36px] h5:pb-[16px]">
                <input type="text"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  className="flex-1 px-[15px] py-[10px] rounded-md outline-none text-[#181512] text-[18px]"
                  style={{
                    border: "1px solid #cfc8d8",
                  }} />
              </div>
            </div>
            <div className="w-[8%]"></div>
            <div className="flex-1">
              <div className="flex items-center mb-[20px] text-[#181512] text-[18px] h5:mb-10">
                公司名稱 (選填)
              </div>
              <div className="flex pb-[36px] h5:pb-[16px]">
                <input type="text"
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                  className="flex-1 px-[15px] py-[10px] rounded-md outline-none text-[#181512] text-[18px]"
                  style={{
                    border: "1px solid #cfc8d8",
                  }} />
              </div>
            </div>
          </div>
          <div className="flex h5:block">
            <div className="flex-1">
              <div className="flex items-center mb-[20px] text-[#181512] text-[18px] h5:mb-10">
                國家
                <div className="text-[red] text-[18px] ml-10">*</div>
              </div>
              <div className="flex pb-[36px] font-bold h5:pb-[16px]">
                台灣
              </div>
            </div>
            <div className="w-[8%]"></div>
            <div className="flex-1">
              <div className="flex items-center mb-[20px] text-[#181512] text-[18px] h5:mb-10">
                縣 / 市
                <div className="text-[red] text-[18px] ml-10">*</div>
              </div>
              <div className="flex pb-[36px] h5:pb-[16px]">
                <Select
                  defaultValue=''
                  placeholder="请选择县市"
                  value={county}
                  style={{ width: 120 }}
                  onChange={handleCountyChange}
                  className="flex-1 px-[15px] py-[10px] rounded-md outline-none text-[#181512] text-[18px]"
                  options={countyOptions}
                /> 
              </div>
            </div>
          </div>
          <div className="flex h5:block">
            <div className="flex-1">
              <div className="flex items-center mb-[20px] text-[#181512] text-[18px] h5:mb-10">
                鄉鎮市
                <div className="text-[red] text-[18px] ml-10">*</div>
              </div>
              <div className="flex pb-[36px] h5:pb-[16px]"> 
                <Select
                  defaultValue=""
                  placeholder="請選擇鎮 / 區"
                  value={town}
                  style={{ width: 160 }}
                  onChange={handleTownChange}
                  disabled={!county}
                  className="flex-1 px-[15px] py-[10px] rounded-md outline-none text-[#181512] text-[18px]"
                  options={townOptions}
                />
              </div>
            </div>
            <div className="w-[8%]"></div>
            <div className="flex-1">
              <div className="flex items-center mb-[20px] text-[#181512] text-[18px] h5:mb-10">
                郵遞區號
                <div className="text-[red] text-[18px] ml-10">*</div>
              </div>
              <div className="flex pb-[36px] h5:pb-[16px]">
                <input type="text"
                  value={postalCode}
                  onChange={(e) => setPostalCode(e.target.value)}
                  className="flex-1 px-[15px] py-[10px] rounded-md outline-none text-[#181512] text-[18px]"
                  style={{
                    border: "1px solid #cfc8d8",
                  }} />
              </div>
            </div>
          </div>
          <div className="flex h5:block">
            <div className="flex-1">
              <div className="flex items-center mb-[20px] text-[#181512] text-[18px] h5:mb-10">
                街道地址
                <div className="text-[red] text-[18px] ml-10">*</div>
              </div>
              <div className="flex pb-[36px] h5:pb-[16px]">
                <input type="text"
                  value={streetAddress}
                  onChange={(e) => setStreetAddress(e.target.value)}
                  className="flex-1 px-[15px] py-[10px] rounded-md outline-none text-[#181512] text-[18px]"
                  style={{
                    border: "1px solid #cfc8d8",
                  }} />
              </div>
            </div>
          </div>
          <div
            onClick={() => {
              if (addressLi.length > 0) {
                handlEdit()
              } else {
                handleAdd()
              }
            }}
            className="bg-[#6d6e71] rounded-[4px] inline-block px-[50px] py-[16px] text-[#fff] text-[18px] cursor-pointer
                    hover:bg-[#000]">
            儲存地址
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComponentName;
